import HTTP from '../HTTP';

const URL_BASE = 'commun/Settings/';

export async function changeSetting(key, value) {
  const response = await HTTP.post(URL_BASE + 'ChangeSettingAsync', { key: key, value: value });
  return response;
}

export async function changeSettingForUser(key, value) {
  const response = await HTTP.post(URL_BASE + 'ChangeSettingForUserAsync', { key: key, value: value });
  return response;
}

export async function get(key) {
  const response = await HTTP.get(URL_BASE + 'GetSettingAsync', { params: { key: key } });
  return response;
}
